// extracted by mini-css-extract-plugin
export default {"root":"BackendNotifications_root__-d+bG","notifications":"BackendNotifications_notifications__lhCAE"};